import { message } from 'antd';
import { thresholdImageSize } from './constants'

export const beforeImageUpload = (file) => {
  const isJpgOrPng =
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG/webp file!');
  }
  const isValidSizedImage = file.size / 1024 / 1024 < thresholdImageSize;
  if (!isValidSizedImage) {
    message.error(`Image must smaller than ${thresholdImageSize}MB!`);
  }
  return isJpgOrPng && isValidSizedImage;
};
